
const moduleFiles: any = require.context('./', false, /\.js|ts$/)
const langModules:any = moduleFiles.keys().reduce((modules: any, modulePath:string) => {
  const moduleName:string = modulePath.replace(/^\.\/(.*)\.\w+$/,"$1")
  const value = moduleFiles(modulePath)
  moduleName !== 'index' ? modules[moduleName] = value.default : ''
  return modules
},{})
export default langModules
